export function getCardExpiryDate(goodThru?: string) {
  if (goodThru?.length !== 4) {
    return {
      expiryDate: 'MM/YY',
      isExpired: true,
    };
  }

  const month = goodThru.slice(0, 2);
  const year = goodThru.slice(2, 4);
  const isExpired = +new Date() > +new Date(Number(`20${year}`), Number(`${Number(month) - 1}`), 1);

  return {
    expiryDate: `${month}/${year}`,
    isExpired,
  };
}

export function formatCardBrand(ePayType?: string) {
  switch (ePayType?.toUpperCase()) {
    case 'VISA':
      return 'Visa';
    case 'MASTERCARD':
      return 'Mastercard';
    case 'AMERICANEXPRESS':
      return 'AMEX';
    case 'DISCOVER':
      return 'Discover';
    case 'ACH':
      return 'ACH';
    default:
      return ePayType ?? '';
  }
}

export function getLastFour(cardEnding?: string) {
  return cardEnding ? cardEnding.slice(-4) : 'XXXX';
}
